import React from "react";

const Industry = () => {
  return (
    <div>
      <div className="industry">
        <h1 className="text-center text-white">Industries <span className="text-warning bold">We've</span>  Worked For</h1>
        <div className="row">
            <div className="col-md-4">
            <div className="card-container">
          <main>
            <div className="card">
              <img
                src="https://englishpluspodcast.com/wp-content/uploads/2023/05/Access-to-Education.jpg"
                alt
              />
              <div className="card-content">
                <h2>Education Technology</h2>
                <p>
                  Lorem, ipsum dolor sit amet consectetur adipisicing elit.
                  Nesciunt exercitationem iste, voluptatum, quia explicabo
                  laboriosam rem adipisci voluptates cumque, veritatis atque
                  nostrum corrupti ipsa asperiores harum? Dicta odio aut hic.
                </p>
                <a href="#" className="button">
                  Find out more
                  <span className="material-symbols-outlined">
                    arrow_right_alt
                  </span>
                </a>
              </div>
            </div>
          </main>
            </div>
        </div>
        <div className="col-md-4">
            <div className="card-container">
          <main>
            <div className="card">
              <img
                src="https://wallpapercave.com/wp/wp7845825.jpg"
                alt
              />
              <div className="card-content">
                <h2>Food Industry</h2>
                <p>
                  Lorem, ipsum dolor sit amet consectetur adipisicing elit.
                  Nesciunt exercitationem iste, voluptatum, quia explicabo
                  laboriosam rem adipisci voluptates cumque, veritatis atque
                  nostrum corrupti ipsa asperiores harum? Dicta odio aut hic.
                </p>
                <a href="#" className="button">
                  Find out more
                  <span className="material-symbols-outlined">
                    arrow_right_alt
                  </span>
                </a>
              </div>
            </div>
          </main>
            </div>
        </div>
        <div className="col-md-4">
            <div className="card-container">
          <main>
            <div className="card">
              <img
                src="https://miro.medium.com/max/11232/1*Xx9dIim-_cfYtg8N69jIWg.jpeg"
                alt
              />
              <div className="card-content">
                <h2>TeleCommunication</h2>
                <p>
                  Lorem, ipsum dolor sit amet consectetur adipisicing elit.
                  Nesciunt exercitationem iste, voluptatum, quia explicabo
                  laboriosam rem adipisci voluptates cumque, veritatis atque
                  nostrum corrupti ipsa asperiores harum? Dicta odio aut hic.
                </p>
                <a href="#" className="button">
                  Find out more
                  <span className="material-symbols-outlined">
                    arrow_right_alt
                  </span>
                </a>
              </div>
            </div>
          </main>
            </div>
        </div>
      
        </div>
      </div>
    </div>
  );
};

export default Industry;
